module.exports = __webpack_public_path__ + "img/link-tbdp.7ccdb128.png";